/*
  Poster-gallery carousel: vertical-slide dot indicators + click-to-scroll.

  Each [data-ms-carousel] block has:
    - a [data-ms-carousel-track] scroll container with scroll-snap-y
    - N [data-ms-slide] children (full-height each)
    - N [data-ms-dot] buttons (one per slide, document-order)

  IntersectionObserver against the track tracks which slide is most visible
  and updates the active dot. Clicking a dot scrolls the track to that slide.
  No autoplay (manual scroll / swipe / dot-click only).
*/
(() => {
  document.querySelectorAll('[data-ms-carousel]').forEach(initCarousel);
})();

function initCarousel(carousel) {
  const track = carousel.querySelector('[data-ms-carousel-track]');
  const slides = Array.from(carousel.querySelectorAll('[data-ms-slide]'));
  const dots = Array.from(carousel.querySelectorAll('[data-ms-dot]'));
  if (!track || slides.length === 0 || dots.length === 0) return;

  dots.forEach(dot => {
    dot.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const idx = parseInt(dot.dataset.slideTarget, 10);
      const target = slides[idx];
      if (!target) return;
      track.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
    });
  });

  const setActive = (idx) => {
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
  };

  // 0.6 threshold: a slide must be ≥60% visible inside the track viewport
  // to be considered active. Avoids dot flicker during smooth-scroll.
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
        const idx = slides.indexOf(entry.target);
        if (idx >= 0) setActive(idx);
      }
    });
  }, {
    root: track,
    threshold: [0.6],
  });

  slides.forEach(s => observer.observe(s));
}

/* ============================================================
   Article-preview typewriter — for posters linking to a blog post.
   On hover, type the article's body text into a positioned overlay
   character by character; when the container fills, auto-scroll so
   newer text stays at the bottom and older lines push up out of view.
   Reset on mouseleave so each hover replays from the start.
   ============================================================ */
document.querySelectorAll('[data-ms-poster-typewriter]').forEach(el => {
  const source = el.dataset.source || '';
  if (!source) return;
  const poster = el.closest('.ms-poster');
  if (!poster) return;

  const CHAR_MS = 16;        // ms per char — tuned to feel like real typing
  const MAX_CHARS = 500;     // hard cap so we don't run forever on long posts
  let timer = null;
  let idx = 0;

  const tick = () => {
    if (idx >= source.length || idx >= MAX_CHARS) {
      clearInterval(timer);
      timer = null;
      return;
    }
    el.textContent += source[idx];
    idx++;
    // Keep newest line visible — pushes older content out the top
    el.scrollTop = el.scrollHeight;
  };

  const start = () => {
    if (timer) return;
    idx = 0;
    el.textContent = '';
    el.scrollTop = 0;
    timer = setInterval(tick, CHAR_MS);
  };

  const stop = () => {
    if (timer) { clearInterval(timer); timer = null; }
    el.textContent = '';
    idx = 0;
  };

  poster.addEventListener('mouseenter', start);
  poster.addEventListener('mouseleave', stop);

  // Mobile (≤749px): trigger the typewriter via IntersectionObserver
  // instead of hover. Fires when the poster crosses the middle ~40% of
  // the viewport — feels like "the image hits the middle" as the user
  // scrolls. Re-fires if the user scrolls away and back.
  if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          poster.classList.add('is-in-view');
          start();
        } else {
          poster.classList.remove('is-in-view');
          stop();
        }
      });
    }, {
      // Shrink the intersection root by 30% top/bottom — only the
      // middle 40% band of the viewport counts as "in view".
      rootMargin: '-30% 0px -30% 0px',
      threshold: 0,
    });
    io.observe(poster);
  }
});
